import { Box, Typography } from '@mui/material';
import { PropsWithChildren } from 'react';

export interface BudgetMonthPanelProps {
  title?: string;
  actions?: React.ReactNode;
}

const BudgetMonthPanel = ({
  title,
  actions,
  children
}: PropsWithChildren<BudgetMonthPanelProps>) => {
  return (
    <Box sx={{ width: '100%', mb: 2 }}>
      {(title || actions) && (
        <Box
          sx={{
            mb: 2,
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center'
          }}
        >
          {title && <Typography variant="h6">{title}</Typography>}
          {actions && <Box>{actions}</Box>}
        </Box>
      )}
      {children}
    </Box>
  );
};

export default BudgetMonthPanel;
